import { useT } from "../i18n/index";

// The TCKN input — TCKN is NON-SECRET (never a password), but the client NEVER echoes
// the full number: the input is masked (type=password) and the live preview shows only
// bullets + a digit count, never the digits. The raw value is held by the parent for
// submission (over HTTPS); "Sunucuda doğrulanır" states that verification is server-side.
export function TcknField({ value, onChange }: { value: string; onChange: (v: string) => void }) {
  const { t } = useT();
  const masked = value.length ? `${"•".repeat(value.length)}  (${value.length}/11)` : "";
  return (
    <div className="ui-field">
      <label>
        {t("onb.tcknLabel")}
        <input
          className="ui-input"
          type="password"
          inputMode="numeric"
          autoComplete="off"
          aria-label={t("onb.tcknLabel")}
          value={value}
          onChange={(e) => onChange(e.target.value.replace(/\D/g, "").slice(0, 11))}
        />
      </label>
      <span className="muted" data-testid="tckn-mask">
        {masked}
      </span>
      <span className="muted">{t("onb.tcknHint")}</span>
    </div>
  );
}
